module.exports = __webpack_public_path__ + "static/media/bottom_icons_logo.15c57290.png";